import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { requestSearchClaims } from 'containers/IdentificationPage/actions';
import * as utils from 'containers/RecapManagerPage/utils';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import { makeSelectPendingClaims } from 'containers/ManagerPendingClaims/selectors';
import { AssignedClaim } from 'containers/CourtManagerAssignedClaims/typings';
import { requestFindClaims } from 'containers/IdentificationPage/actions';
import { makeSelectLastClaims } from 'containers/ManagerHomePage/selectors';
import {
  setSearchQueryMonitoringManager,
  setSelectedResultSearch,
} from 'containers/ManagerHomePage/actions';
import { makeSelectListingsByField } from 'containers/AppContainer/selectors';
import { resetStoreClaim } from 'containers/RecapManagerPage/actions';
import { resetTabsIndex } from 'containers/AppContainer/actions';
import AssignedClaimsTable from 'containers/ManagerHomePage/AssignedClaimsTable';
import SearchContainer from 'containers/IdentificationPage/SearchContainer';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import { requestLastAssignedClaims } from 'containers/ManagerHomePage/actions';
import { SearchQuery } from 'containers/IdentificationPage/typings';
import { LISTINGS } from 'containers/data-structure';
import { requestManagerPendingClaims } from 'containers/ManagerPendingClaims/actions';
import { resetSearchClaimsStore } from 'containers/IdentificationPage/actions';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';

export interface TransactionManagerHomePageProps {
  intl: IntlShape;
  requestManagerPendingClaims: Function;
  requestFindClaims: Function;
  pendingClaims: [];
  cities: SagisConfig[];
  requestLastAssignedClaims: Function;
  lastAssignedClaims: AssignedClaim[];
  listings: Listings;
  setSearchQueryMonitoringManager: Function;
  setSelectedResultSearch: Function;
  policyInfo: any;
  resetSearchClaimsStore: Function;
  resetStoreClaim: Function;
  resetTabsIndex: Function;
  requestSearchClaims: Function;
}
const StyledAssignedClaimsTable = styled(AssignedClaimsTable)`
  margin-top: 75px;
`;

const TransactionManagerHomePage: React.FC<TransactionManagerHomePageProps> = (
  props,
): JSX.Element => {
  const [firstSearch, setFirstSearch] = React.useState(false);
  React.useEffect(() => {
    props.resetSearchClaimsStore();
    props.resetStoreClaim();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [searchQuery, setSearchQuery] = React.useState<SearchQuery>({
    lossDate: null,
    registrationNumber: null,
    policyNumber: null,
    claimNumber: null,
    assuredCIN: null,
    assuredName: null,
    victimName: null,
    courtNumber: null,
  });
  const submitSearch = () => {
    setFirstSearch(true);
    props.requestFindClaims({
      ...searchQuery,
      procedureNatureId:
        get(searchQuery, 'procedureNatureId') === 0
          ? null
          : get(searchQuery, 'procedureNatureId'),
      jurisdictionDegreeId:
        get(searchQuery, 'jurisdictionDegreeId') === 0
          ? null
          : get(searchQuery, 'jurisdictionDegreeId'),
      jurisdiction:
        get(searchQuery, 'jurisdiction') === '0'
          ? null
          : get(searchQuery, 'jurisdiction'),
      isBasicManagementActive: featureService.hasFeature(
        FEATURES.BASIC_MANAGEMENT,
      ),
    });
  };
  return (
    <div>
      <SearchContainer
        searchQuery={searchQuery}
        onChangeSearchQuery={setSearchQuery}
        submitSearch={submitSearch}
        isManager={true}
      />

      {firstSearch && (
        <>
          <StyledAssignedClaimsTable
            pendingClaims={props.pendingClaims}
            lastAssignedClaims={props.lastAssignedClaims}
            lawyers={utils.getListBySagisKey(
              get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
              get(props.listings, LISTINGS.STACKHOLDERS, []),
              ITEM_KEYS.LAWYER,
              SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
            )}
            isCourtMonitoringManager={userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMONITORINGMANAGER,
            )}
            isConsultationManager={userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCONSULTATIONMANAGER,
            )}
            isOpeningManager={userPrivileges.userHasPrivilege(
              PRIVILEGES.ISOPENINGMANAGER,
            )}
            isTransactionManager={userPrivileges.userHasPrivilege(
              PRIVILEGES.ISTRANSACTIONMANAGER,
            )}
            resetTabsIndex={props.resetTabsIndex}
            setSelectedResultSearch={props.setSelectedResultSearch}
            requestSearchClaims={props.requestSearchClaims}
          ></StyledAssignedClaimsTable>
        </>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  requestManagerPendingClaims,
  requestFindClaims,
  requestLastAssignedClaims,
  setSearchQueryMonitoringManager,
  setSelectedResultSearch,
  resetSearchClaimsStore,
  resetStoreClaim,
  resetTabsIndex,
  requestSearchClaims,
};

const mapStateToProps = createStructuredSelector({
  pendingClaims: makeSelectPendingClaims(),
  cities: makeSelectListingsByField(LISTINGS.CITIES),
  lastAssignedClaims: makeSelectLastClaims(),
  listings: makeSelectListings(),
  policyInfo: makeSelectSearchClaims(),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TransactionManagerHomePage));
